export const FORM_BUILDER_STATUS = {
  ACTIVE: "active",
  ARCHIVED: "archived",
  DRAFT: "draft"
};
export const FORM_BUILDER_PUBLISHED = {
  YES: true,
  NO: false
};
